/**
 * LOS API client (Batch 2).
 *
 * Mirrors backend/src/modules/los/routes/los-routes.ts.
 * All endpoints go through apiRequest which attaches the auth cookie.
 */

import { apiRequest } from './client';
import type { LosApplicationDataDTO } from '@loanaudit/shared';

export interface UploadLosResult {
  losApplicationId: string;
  loanFileId: string;
  sourceAdapter: string;
  applicantCount: number;
  deviationCount: number;
  replacedPrevious: boolean;
  sha256Hex: string;
}

export const losApi = {
  /**
   * Upload LOS data (JSON) for a loan file. Replaces existing data
   * if any. The backend's active adapter (config-driven) validates the
   * raw JSON shape; bad shape → HTTP 400 with details.
   */
  upload: (loanFileId: string, rawJson: unknown) =>
    apiRequest<UploadLosResult>(`/api/los/loan-files/${loanFileId}/upload`, {
      method: 'POST',
      body: { rawJson },
    }),

  /**
   * Fetch LOS data attached to a loan file. Returns `null` when no
   * data is attached yet (valid empty state, not an error).
   */
  get: (loanFileId: string) =>
    apiRequest<LosApplicationDataDTO | null>(`/api/los/loan-files/${loanFileId}`),

  /**
   * Delete LOS data for a loan file. Admin only.
   */
  remove: (loanFileId: string) =>
    apiRequest<{ removed: boolean }>(`/api/los/loan-files/${loanFileId}`, {
      method: 'DELETE',
    }),
};
